export default __webpack_public_path__ + "static/almost-3a5891cb256da4e9a05c6aed81ee6962.png";